import { css } from 'emotion';
import { EpisodesLayout } from '@wix/podcasts-common/dist/settings';

export default function getStyles({ colors, settings }) {
  const isListLayout = settings.episodesLayout === EpisodesLayout.LIST;
  return {
    pageContainer: css(
      isListLayout
        ? {
            border: `${settings.borderWidth}px solid`,
            borderColor: colors.borderOpacityColor,
          }
        : {},
    ),
  };
}
